import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

type TMockedBarrier = IGenericTask

export const mockedTask: TMockedBarrier = {
  job: {
    project: {
      code: 'BI02',
      description: 'Billings Maintenance Project',
      isActive: true,
      id: 40,
    },
    location: {
      code: 'BIL.REF STORE',
      description: 'REFINERY STORAGE',
      isActive: true,
      id: 487,
    },
    plantSection: {
      code: 'BIL.F2C',
      description: 'FUELS 2C Asphalt/BOHO/TK Farms/U-ll/Offsites',
      isActive: true,
      id: 116,
    },
    leadSupervisor: {
      code: 'BIL.CONTRACTOR FLS',
      description: 'Contractor Coordinator',
      isActive: true,
      id: 344,
    },
    area: {
      code: 'BIL.CONTRACTOR FLS',
      description: 'Contractor Coordinator',
      isActive: true,
      id: 344,
    },
    abcIndicator: 'A',
    code: 'AMP.11414971',
    name: 'INSP_CL1 Iso 1321A Need Scaffold_April17 AMP.11414971',
    projectId: 40,
    locationId: 487,
    leadSupervisorId: 344,
    plantSectionId: 116,
    workOrder: '11414971',
    functionalLocation: 'Refinery Storage Piping',
    equipmentTag: 'BIR-RST-016',
    notification: '13341434',
    id: 44015,
  },
  commentCount: 1,
  jobId: 44015,
  startTime: new Date(),
  duration: 10,
  crewSize: 2,
  needsEquipmentRental: false,
  permitTypeIds: [22],
  permitNeeded: 1,
  operationPostId: 209,
  assignments: [
    {
      description: 'ACUREN TO INSPECT ISO 3121A',
      crewSize: 2,
      duration: 10,
      assignmentIds: [],
      offset: 0,
      taskId: 179084,
      resourceId: 590,
      assigneeIds: [1000190],
      wasDeleted: false,
      resourceDescription: 'Contractor Inspection Services',
      assignees: [
        {
          resourcesIds: [],
          description: 'Jack of All Trades',
          crewSize: 1,
          shiftHours: 8.1,
          alias: 'JAT',
          supervisorIds: [],
          id: 1000190,
        },
      ],
      id: 269773,
    },
  ],
  jobTaskCount: 4,
  jobName: 'INSP_CL1 Iso 1321A Need Scaffold_April17 AMP.11414971',
  location: 'REFINERY STORAGE',
  permitTypes: [
    {
      description: 'Cold Work',
      isActive: true,
      id: 22,
    },
  ],

  projectId: 40,
  functionalLocation: 'Refinery Storage Piping',
  notification: '13341434',
  barrierCount: 2,
  status: 'completed',
  isPullAhead: false,
  isReset: false,
  isSplit: false,
  isComplete: true,
  permitStatus: 1,
  sequence: 0,
  sequentialCode: 'AMP.11414971.0030',
  name: 'ACUREN TO INSPECT ISO 3121A',
  code: 'AMP.11414971.0030',
  workOrder: '11414971',
  hasBarrier: true,
  isBreakIn: false,
  equipmentTag: 'BIR-RST-016',
  id: 179084,
  createdOn: new Date(),
}
